import { __assign, __rest } from "tslib";
import { useContext, useCallback, useRef, useEffect } from 'react';
import { logger } from '../BiLogger.logger';
import { BiContext } from '../BiLogger.context';
import { SessionContext } from '../../Context';
export function useBiLogger() {
    var biContext = useContext(BiContext);
    var publicSession = useContext(SessionContext);
    // The following is outright cheating the memoization system, but we want
    // to make sure logEvent is a single, stable instance. So instead of forcing
    // it to recreate the callback every time the contexts update to keep the
    // closure from going stale, we keep non-rerendering refs that provide the
    // latest values for it.
    var contextMemoForOptimization = useRef(biContext);
    var sessionMemoForOptimization = useRef(publicSession);
    useEffect(function () {
        contextMemoForOptimization.current = biContext;
        sessionMemoForOptimization.current = publicSession;
    }, [biContext, publicSession]);
    var logEvent = useCallback(function (eventData) {
        var mergedData = __assign(__assign({}, contextMemoForOptimization.current), eventData);
        var _rankIndex = mergedData._rankIndex, _rankOffset = mergedData._rankOffset, href = mergedData.href, biData = __rest(mergedData, ["_rankIndex", "_rankOffset", "href"]);
        if (typeof _rankOffset !== 'undefined' &&
            typeof _rankIndex !== 'undefined') {
            biData.rank = _rankOffset + _rankIndex;
        }
        return logger.log(sessionMemoForOptimization.current, biData);
    }, []);
    return logEvent;
}
//# sourceMappingURL=useBiLogger.js.map